import React, { useState } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../utilities/Validator";
import "../../css/common.css";
const DateInput = ({
  max,
  min,
  onChange,
  value,
  label,
  inputClass,
  required,
  labelClass,
  disabled,
  validators,
  getError,
  name,
  Error,
  dateClass,
  type
}) => {
  // const getMax = () => {
  //   return new Date().toISOString().substring(0, 10);
  // };
  // const getMin = () => {
  //   return new Date().toISOString().substring(0, 10);
  // }
  const [error, setError] = useState(false);
  const handleChange = (event) => {
    const { value } = event.target;
    if (validateInput(validators, value))
      setError(validateInput(validators, value));
    else if (
      // type === "email" &&
      !validateInput(validators, value) &&
      value !== ""
    ) {
      setError(false);
    } else {
      setError(false);
    }
    onChange(value);
    getError &&
      getError(
        validateInput(validators, value)
          ? validateInput(validators, value)
          : false
      );
  };

  
  return (
    <>
      {label && (
        <div className={labelClass}>
          <label className="date-label">
            {label} {required && <b className={"text-danger"}>*</b>}
          </label>
        </div>
      )}
      <div className={inputClass}>
        <input
          type={type}
          name={name}
          max={max }
          value={value}
          onChange={handleChange}
          min={min}
          className={`form-control library-date ${dateClass}`}
          placeholder="Date"
          disabled={disabled}
         // disableEntry={true}
          onKeyDown={(e) => {
            e.preventDefault();
         }}
        />
        {(error || (Error && Error[name])) && <span className="text-danger errormsg">{error.message|| Error[name]}</span>}
      </div>
    </>
  );
};

DateInput.prototype = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
};

DateInput.defaultProps = {
  value: "",
  label: "Date",
  placeholder: "",
  type: "date",
  labelClass: "col-md-4",
  inputClass: "col-md-6",
  name:"date"
};
export default DateInput;
